import React from 'react';
import { Line } from 'react-chartjs-2';

function BoTStatus() {
  const data = {
    labels: ['Decision 1', 'Decision 2', 'Decision 3'],
    datasets: [
      {
        label: 'Decision Timeline',
        data: [3, 5, 2],
        borderColor: 'rgba(75,192,192,1)',
        fill: false
      }
    ]
  };

  return (
    <div className="bot-status">
      <Line data={data} />
      <p>Current Decision: Evaluating new business opportunity</p>
    </div>
  );
}

export default BoTStatus;
